// Module
var code = "<react-component name=\"ManageWebsitePromotions\" props=\"{save: save, websiteData: website}\"></react-component>\n";
// Exports
module.exports = code;